import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { Loading } from "@/layouts/loading";
import { SearchParams } from "@/routes/(pharma)/_layout/accounts/revenue/-model/model";
import { pharmacyClient } from "@/connect";
import { PaymentMethodBreakdownItem } from "@/gen/accounts/common_pb";

export const Route = createFileRoute("/(pharma)/_layout/accounts/payment-method-breakdown/")({
  component: Component,
  validateSearch: SearchParams,
  loaderDeps: ({ search: { type, start_date, end_date, time_compare, moving_average, moving_average_days } }) => ({ type, start_date, end_date, time_compare, moving_average, moving_average_days }),
  loader: async (params) => {
    let overlay_data = [] as PaymentMethodBreakdownItem[];
    // Start and End date are unix timestamps
    let start_date = 0
    let end_date = 0
    if (params.deps.type === "CUSTOM" && params.deps.start_date && params.deps.end_date) {
      start_date = params.deps.start_date
      end_date = params.deps.end_date
    }
    if (params.deps.type === "WEEK") {
      start_date = Math.floor(Date.now() / 1000) - 604800
      end_date = Math.floor(Date.now() / 1000)
    }
    if (params.deps.type === "MONTH") {
      start_date = Math.floor(Date.now() / 1000) - 2592000
      end_date = Math.floor(Date.now() / 1000)
    }
    if (params.deps.type === "QUATER") {
      start_date = Math.floor(Date.now() / 1000) - 7776000
      end_date = Math.floor(Date.now() / 1000)
    }
    if (params.deps.type === "HALF_YEAR") {
      start_date = Math.floor(Date.now() / 1000) - 15552000
      end_date = Math.floor(Date.now() / 1000)
    }
    if (params.deps.type === "YEAR") {
      start_date = Math.floor(Date.now() / 1000) - 31536000
      end_date = Math.floor(Date.now() / 1000)
    }
    const response = await pharmacyClient.accountsPaymentMethodBreakdown({
      startDate: start_date,
      endDate: end_date,
    })

    if (params.deps.time_compare) {

      const response = await pharmacyClient.accountsPaymentMethodBreakdown({
        startDate: start_date - (end_date - start_date),
        endDate: start_date,
      });

      overlay_data = response.paymentMethodBreakdownItems;
    }

    return {
      currentData: response.paymentMethodBreakdownItems,
      overlayData: overlay_data
    }
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1
});
